import cx from 'classnames'
import type { PropsWithChildren } from 'react'

type Props = PropsWithChildren & {
  className?: string
}

export const CardAutoLayout = ({ className, children }: Props) => (
  <div className={cx('grid-cols-(--cols-auto-fit) grid gap-2', className)}>
    {children}
  </div>
)
